var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.682c-.48 0-.8.32-.8.8 0 .32.24.56.48.64l-.24 1.12h1.04l-.24-1.12c.32-.08.48-.32.48-.64.08-.48-.24-.8-.72-.8zm.08-3.44c-.56 0-1.12.4-1.12.96v1.2h2.16v-1.2c-.08-.56-.48-.96-1.04-.96zM8 1.602l-5.6 2.4v2.4c.08 3.52 2.32 6.64 5.6 7.92 3.28-1.28 5.52-4.4 5.6-7.92v-2.4L8 1.602zm3.2 8.8c0 .48-.32.8-.8.8H5.6c-.48 0-.8-.32-.8-.8v-3.2c0-.48.32-.8.8-.8h.24v-1.2c.08-1.12 1.04-2 2.16-2s2.08.88 2.16 2v1.2h.24c.48 0 .8.32.8.8v3.2z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/privacy-icon.93326815cbda0599ded60c7a6329056b.svg";
export { ForwardRef as ReactComponent };